import * as React from 'react';

export default class Footer extends React.Component {
  render() {
    return (
      <div className="Footer">
        &copy; 2019 How a Car works. All rights reserved.
      </div>
    )
  }
}
